export class Coin {
    constructor(amount, denom) {
        this.amount = amount;
        this.denom = denom;
    }
    asJson() {
        return { amount: this.amount.toString(), denom: this.denom };
    }
    validate() {
        if (!Number.isInteger(this.amount))
            throw Error('amount is not an integer');
        if (this.amount < 0)
            throw Error('Expect amount more than 0');
        if (this.denom.length === 0)
            throw Error('Expect denom');
        return true;
    }
}
